import axios from "axios";
import moment from "moment";
import * as files from "../../fileUtils";
import users from "../../users";
import { customFakeItem } from "devexpress-dashboard/common/index.internal";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { gmapApi } from "vue2-google-maps";
import gMapStyles from "@/assets/json/gmapstyles.json";
import Vue from "vue";

export default {
  name: "applicationOffline",
  mixins: [users, validationMixin],
  components: {
    google: gmapApi,
    ActivitySelectMeterComp: require("./appDetails/selectMeter/selectMeter.vue")
      .default,
    ActivityReadingsComp: require("./appDetails/readings/readings.vue").default,
    CustomerComplaintComp:
      require("./appDetails/customerComplaint/customerComplaint.vue").default,
    QuotationsComp: require("./appDetails/quotations/quotations.vue").default,
    InvestigationOutcomeComp: require("./appDetails/outcome/outcome.vue")
      .default,
    OmJobcardComp: require("./appDetails/omJobcard/omJobcard.vue").default,
    SelectCustomer: require("./appDetails/selectCustomer/selectCustomer.vue")
      .default,
    SelectProperty: require("./appDetails/selectProperty/selectProperty.vue")
      .default,
    SelectConnection:
      require("./appDetails/selectConnection/selectConnection.vue").default,

    CustomFieldsComp: require("../../components/customFields.vue").default,
  },
  data: function () {
    return {
      taskTypes: taskTypesDef,
      activityId: 0,
      activity: null,
      app: {
        id: -1,
        key: 0,
        type: "",
        currentActivityId: -1,
        currentTask: "",
        assignedEmployeeId: -1,
        assignedEmployee: "",
      },
      nextActivities: [],
      workFlowActivities: [],
      nextSelectedAppKey: 0,

      gMapPositions: [
        { lat: 0, lng: 0 },
        { lat: 0, lng: 0 },
      ],
      dataObj: null,
    };
  },
  created() {
    this.app.id = this.$route.params.id;
    this.showTask();
  },
  methods: {
    showTask() {
      if (
        !this.$store.state.offlineApplicationsData ||
        !this.$store.state.offlineApplicationsData.appViews
      )
        this.$router.push("/applications");

      this.workFlowActivities = [];

      let currActivity =
        this.$store.state.offlineApplicationsData.appViews.filter(
          (q) => q.applicationId == this.$route.params.id
        )[0].lastActivityAppKey;

      this.activity =
        this.$store.state.offlineApplicationsData.appKeyToActivityInfo[
          currActivity
        ];

      //If activity is not found (not supported in offline) skipe to next in line
      if (!this.activity) {
        const typeId =
          this.$store.state.offlineApplicationsData.appViews.filter(
            (q) => q.applicationId == this.$route.params.id
          )[0].typeId;

        const workflow =
          this.$store.state.offlineApplicationsData.appTypeWorkflows[typeId];

        if (Array.isArray(workflow) && workflow.length > 0) {
          for (let w of workflow) {
            if (w.appKey == currActivity) {
              currActivity = w.nextAppKey;
              this.activity =
                this.$store.state.offlineApplicationsData.appKeyToActivityInfo[
                  currActivity
                ];
              break;
            }
          }
        }
      }

      if (!this.activity) {
        this.$router.push("/applications");
        return;
      }

      const lastAct =
        this.$store.state.offlineApplicationsData.appActivities[
          this.$route.params.id
        ][currActivity];

      console.log("curActivity", currActivity);
      console.log(
        "activity",
        this.activity ? JSON.parse(JSON.stringify(this.activity)) : "-"
      );
      console.log("lastAct", lastAct);
      let temp;

      switch (this.activity.activityType) {
        case taskTypesDef.InvestigationOutcome.type:
          this.dataObj = {
            currActivity,
            appId: this.app.id,
            activityId: this.activity.activityType,
            outcome: lastAct.data,
            customFields: { items: lastAct.customFields },
            isCompleted: lastAct.isCompleted,
            isSaved: lastAct.isSaved,
            readOnly: false,
            location: lastAct.location,
          };
          this.app.currentActivityId = this.activity.activityType;
          break;

        case taskTypesDef.CustomerComplaint.type:
          this.dataObj = {
            currActivity,
            appId: this.app.id,
            activityId: this.activity.activityType,
            complaint: lastAct.data,
            readOnly: false,
            complaintTypes:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["complaintTypes"],
            complaintSubtypes:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["complaintSubtypes"],
            suggestedActivities:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["suggestedActivities"],
            customFields: { items: lastAct.customFields },
            isCompleted: lastAct.isCompleted,
            isSaved: lastAct.isSaved,
            location: lastAct.location,
          };
          this.app.currentActivityId = this.activity.activityType;
          break;

        case taskTypesDef.GetMeterReading.type:
          this.dataObj = {
            currActivity,
            appId: this.app.id,
            activityId: this.activity.activityType,
            isAllowChangeDate: lastAct.data.isAllowChangeDate,
            readings: lastAct.data.readings,
            customFields: { items: lastAct.customFields },
            isCompleted: lastAct.isCompleted,
            isSaved: lastAct.isSaved,
            readOnly: false,
            location: lastAct.location,
          };
          this.app.currentActivityId = this.activity.activityType;
          break;

        case taskTypesDef.SelectMeter.type:
          let model = lastAct.data;
          model.selectMeterEnabled =
            lastAct && lastAct.data && lastAct.data.selectMeterEnabled;
          model.isNewMeter = true;

          temp =
            this.$store.state.offlineApplicationsData.activityLookups[
              this.activity.appKey
            ];

          if (temp && temp["meters"] && temp["meters"].length > 0)
            model.type =
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["meters"][0].value;
          else model.type = "";

          this.dataObj = {
            currActivity,
            appId: this.app.id,
            activityId: this.activity.activityType,
            conditions:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["conditions"],
            makes:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["makes"],
            sizes:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["sizes"],
            types:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["types"],
            warehouses:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["warehouses"],
            selectMeterEnabled: lastAct.data.selectMeterEnabled,
            enterMeterEnabled: lastAct.data.enterMeterEnabled,
            meterModel: model,
            customFields: { items: lastAct.customFields },
            isCompleted: lastAct.isCompleted,
            isSaved: lastAct.isSaved,
            readOnly: false,
            location: lastAct.location,
          };

          this.app.currentActivityId = this.activity.activityType;
          break;

        case taskTypesDef.Quotation.type:
          this.dataObj = {
            currActivity,
            appId: this.app.id,
            activityId: this.activity.activityType,
            data: lastAct.data,
            customFields: { items: lastAct.customFields },
            isCompleted: lastAct.isCompleted,
            isSaved: lastAct.isSaved,
            location: lastAct.location,
          };
          this.app.currentActivityId = this.activity.activityType;
          break;

        case taskTypesDef.IssueJobcard.type:
          this.dataObj = {
            currActivity,
            appId: this.app.id,
            activityId: this.activity.activityType,
            data: lastAct.data,
            appData: lastAct.data,
            customFields: { items: lastAct.customFields },
            isCompleted: lastAct.isCompleted,
            isSaved: lastAct.isSaved,
            location: lastAct.location,
          };
          this.app.currentActivityId = this.activity.activityType;
          break;

        case taskTypesDef.SelectCustomer.type:
          const customers =
            this.$store.state.offlineApplicationsData.activityLookups[
              this.activity.appKey
            ]["customers"];
          const customer =
            lastAct.data.item && lastAct.data.item.customerKey
              ? lastAct.data.item.customerKey
              : -1;
          temp = customers.filter((c) => c.customerKey == customer);

          let selectedCust = {};
          if (temp && temp.length > 0) selectedCust = temp[0];

          this.dataObj = {
            currActivity,
            appId: this.app.id,
            appKey: this.activity.appKey,
            currentActivityId: this.activity.activityType,
            billingGroups: [],
            consumerTypes:
              this.$store.state.offlineApplicationsData.activityLookups[
                this.activity.appKey
              ]["consumerTypes"],
            customer: selectedCust,
            completeTask: lastAct.data.isCompleted,
            customers: [],
            filterObj: [],
            showSelectedPanel: false,
            readOnly: false,
            propertyId: -1,
            isSelectCustomerProperty: false,
          };
          this.app.currentActivityId = this.activity.activityType;
          break;

        case taskTypesDef.SelectProperty.type:
          const properties =
            this.$store.state.offlineApplicationsData.activityLookups[
              this.activity.appKey
            ]["properties"];
          const property =
            lastAct.data.item && lastAct.data.item.propertyId
              ? lastAct.data.item.propertyId
              : -1;
          temp = properties.filter((c) => c.propertyId == property);

          let selectedProp = {};
          if (temp && temp.length > 0) selectedCust = temp[0];

          this.dataObj = {
            currActivity,
            appId: this.app.id,
            appKey: this.activity.appKey,
            currentActivityId: this.activity.activityType,
            towns: [],
            townships: [],
            property: selectedProp,
            completeTask: lastAct.data.isCompleted,
            readOnly: false,
          };
          this.app.currentActivityId = this.activity.activityType;
          break;

        case taskTypesDef.SelectConnection.type:
          const connections =
            this.$store.state.offlineApplicationsData.activityLookups[
              this.activity.appKey
            ]["connections"];
          const connection =
            lastAct.data &&
            lastAct.data.items &&
            lastAct.data.items.length > 0 &&
            lastAct.data.items[0].connectionId
              ? lastAct.data.items[0].connectionId
              : -1;
          temp = connections.filter((c) => c.connectionId == connection);

          let selectedConnection = {};
          let selectedConnections = [];
          if (temp && temp.length > 0) {
            selectedConnection = temp;
            selectedConnections = [temp];
          }

          let prof = this.$store.getters.getUserProfile;

          let isFieldWorker =
            prof && prof.isFieldWorker ? prof.isFieldWorker : true;

          this.dataObj = {
            currActivity,
            appId: this.app.id,
            appKey: this.activity.appKey,
            currentActivityId: this.activity.activityType,
            connectionId: selectedConnection,
            connectionIds: selectedConnection,
            allowMultipleSelect: false,
            currentConnections: [],
            mode: null,
            completeTask: lastAct.data.isCompleted,
            readOnly: false,
            isFieldWorker: isFieldWorker,
          };

          this.app.currentActivityId = this.activity.activityType;
          break;
      }
    },
    saveTask() {
      this.getLocation();

      if (!this.activity || !this.activity.activityType) {
        this.$router.push("/applications");
        return;
      }

      switch (this.activity.activityType) {
        case taskTypesDef.InvestigationOutcome.type:
          this.saveInvestigationOutcome();
          break;
        case taskTypesDef.CustomerComplaint.type:
          this.saveComplaint();
          break;
        case taskTypesDef.GetMeterReading.type:
          this.saveReadings();
          break;
        case taskTypesDef.SelectMeter.type:
          this.saveSelectMeter();
          break;
        case taskTypesDef.Quotation.type:
          this.saveQuotation();
          break;
        case taskTypesDef.IssueJobcard.type:
          this.saveJobcard();
          break;
        case taskTypesDef.SelectCustomer.type:
          this.saveSelectCutomer();
          break;
        case taskTypesDef.SelectProperty.type:
          this.saveSelectProperty();
          break;
        case taskTypesDef.SelectConnection.type:
          this.saveSelectConnection();
          break;
      }
    },
    saveInvestigationOutcome() {
      if (!this.$refs.outcome.validateAppData()) return;

      this.save();
    },
    saveComplaint() {
      this.save();
    },
    saveReadings() {
      this.save();
    },
    saveSelectMeter() {
      if (!this.$refs.selectMeter.validateAppData()) return;

      this.save();
    },
    saveQuotation() {
      if (!this.$refs.quotations.validateAppData()) return;

      this.save();
    },
    saveJobcard() {
      this.save();
    },
    saveSelectCutomer() {
      if (this.dataObj.customer.customerKey) this.save();
    },
    saveSelectProperty() {
      if (this.dataObj.property.propertyId) this.save();
    },
    saveSelectConnection() {
      if (this.dataObj.connectionId) this.save();
    },

    goToApplications() {
      this.$router.push("/applications");
    },
    checkNextActivity() {
      let currApp = this.$store.state.offlineApplicationsData.appViews.filter(
        (q) => q.applicationId == this.$route.params.id
      )[0];

      this.workFlowActivities =
        this.$store.state.offlineApplicationsData.appTypeWorkflows[
          currApp.typeId
        ].filter(
          (a) => a.appKey == currApp.lastActivityAppKey && a.isAllowed == true
        );

      //this.workFlowActivities = this.$store.state.offlineApplicationsData.

      if (this.workFlowActivities.length === 0) {
        //this.$router.push('/applications');
        this.$router.go(-1);
      } else if (this.workFlowActivities.length === 1) {
        this.$store.state.offlineApplicationsData.appViews.filter(
          (q) => q.applicationId == this.$route.params.id
        )[0].lastActivityAppKey = this.workFlowActivities[0].nextAppKey;

        let newTaskObject;

        newTaskObject =
          this.$store.state.offlineApplicationsData.appActivities[
            this.$route.params.id
          ][this.workFlowActivities[0].nextAppKey];

        Vue.set(
          this.$store.state.offlineApplicationsData.appActivities[
            this.$route.params.id
          ],
          this.workFlowActivities[0].nextAppKey,
          newTaskObject
        );

        this.showTask();
      } else {
        this.app.currentActivityId = 0;

        this.nextActivities = [];

        for (let i = 0; i < this.workFlowActivities.length; i++) {
          this.nextActivities.push(
            this.$store.state.offlineApplicationsData.appKeyToActivityInfo[
              this.workFlowActivities[i].nextAppKey
            ]
          );
        }

        this.nextSelectedAppKey = this.nextActivities[0].appKey;
      }
    },
    selectTask() {
      this.$store.state.offlineApplicationsData.appViews.filter(
        (q) => q.applicationId == this.$route.params.id
      )[0].lastActivityAppKey = this.nextSelectedAppKey;
      let newTaskObject;

      newTaskObject =
        this.$store.state.offlineApplicationsData.appActivities[
          this.$route.params.id
        ][this.nextSelectedAppKey];

      Vue.set(
        this.$store.state.offlineApplicationsData.appActivities[
          this.$route.params.id
        ],
        this.nextSelectedAppKey,
        newTaskObject
      );

      this.workFlowActivities = [];
      this.nextActivities = [];

      this.showTask();
    },
    save() {
      let lastAct = this.$store.state.offlineApplicationsData.appViews.filter(
        (a) => a.applicationId == this.dataObj.appId
      )[0]["lastActivityAppKey"];

      if (
        this.$store.state.offlineApplicationsData.appKeyToActivityInfo[lastAct]
          .activityType == 20
      ) {
        this.dataObj.readings[0].currentReading.reading = Number(
          this.dataObj.readings[0].currentReading.reading
        );
      }

      const appKeyToActivityInfo =
        this.$store.state.offlineApplicationsData.appKeyToActivityInfo[lastAct];
      let actData = {
        activityId: appKeyToActivityInfo.activityType,
        appKey: lastAct,
        activityStr: appKeyToActivityInfo.activityStr,
        customFieldValues:
          this.$store.state.offlineApplicationsData.appActivities[
            this.dataObj.appId
          ][lastAct].customFields,
        location: {
          ApplicationId: this.dataObj.appId,
          CoordLat: this.gMapPositions[0].lat,
          CoordLong: this.gMapPositions[0].lng,
        },
        activity: {},
      };

      switch (appKeyToActivityInfo.activityType) {
        case taskTypesDef.InvestigationOutcome.type:
          actData.activity = {
            EmployeeId:
              this.$store.state.offlineApplicationsData.appActivities[
                this.dataObj.appId
              ][lastAct].data.employeeData.employeeId,
            Remarks:
              this.$store.state.offlineApplicationsData.appActivities[
                this.dataObj.appId
              ][lastAct].data.remarks,
          };
          break;
        case taskTypesDef.Quotation.type:
          actData.activity =
            this.$store.state.offlineApplicationsData.appActivities[
              this.dataObj.appId
            ][lastAct].data.quotations;
          break;
        case taskTypesDef.CustomerComplaint.type:
          actData.activity = {
            ComplaintTypeId: this.dataObj.complaint.complaintTypeId,
            ComplaintSubtypeId: this.dataObj.complaint.complaintSubtypeId,
            ConnectionId: Number(this.dataObj.complaint.connectionId),
            PropertyId: Number(this.dataObj.complaint.propertyId),
            Description: this.dataObj.complaint.description,
            ProblemLocation: this.dataObj.complaint.problemLocation,
            IsOwner: this.dataObj.complaint.isOwner,
          };
          break;
        case taskTypesDef.GetMeterReading.type:
          actData.activity = JSON.parse(
            JSON.stringify(this.dataObj.readings[0].currentReading)
          );
          break;
        case taskTypesDef.SelectMeter.type:
          actData.activity = JSON.parse(
            JSON.stringify(
              this.dataObj.meterModel && this.dataObj.meterModel.isNewMeter
                ? this.dataObj.customMeterModel
                : this.dataObj.meterModel
            )
          );
          break;
        case taskTypesDef.IssueJobcard.type:
          actData.activity = JSON.parse(JSON.stringify(this.dataObj.appData));
          break;
        case taskTypesDef.SelectCustomer.type:
          actData.activity = {
            customerKey: this.dataObj.customer.customerKey,
            propertyId: this.dataObj.propertyId,
          };
          break;
        case taskTypesDef.SelectProperty.type:
          actData.activity = {
            propertyId: this.dataObj.property.propertyId,
          };
          break;
        case taskTypesDef.SelectConnection.type:
          actData.activity = {
            connectionID: this.dataObj.connectionId,
          };
          break;
      }

      // console.log(this.dataObj);
      // console.log(actData);

      // position: this.gMapPositions[0]
      console.log("id", this.dataObj.appId);
      this.$store.state.csLocalDB
        .get(this.dataObj.appId)
        .then((doc) => {
          let acts = doc.activities;

          acts.push(actData);

          this.$store.state.csLocalDB.put({
            _id: this.dataObj.appId,
            _rev: doc._rev,
            applicationId: Number(this.dataObj.appId),
            applicationType:
              this.$store.state.offlineApplicationsData.appViews.filter(
                (a) => a.applicationId == this.dataObj.appId
              )[0].applicationTypeS,
            activities: acts,
          });
        })
        .then((response) => {
          this.checkNextActivity();
        })
        .catch((err) => {
          if (err.status == 404) {
            let activity = {};

            switch (
              this.$store.state.offlineApplicationsData.appKeyToActivityInfo[
                lastAct
              ].activityType
            ) {
              case taskTypesDef.InvestigationOutcome.type:
                activity = {
                  EmployeeId:
                    this.$store.state.offlineApplicationsData.appActivities[
                      this.dataObj.appId
                    ][lastAct].data.employeeData.employeeId,
                  Remarks:
                    this.$store.state.offlineApplicationsData.appActivities[
                      this.dataObj.appId
                    ][lastAct].data.remarks,
                };
                break;
              case taskTypesDef.Quotation.type:
                activity =
                  this.$store.state.offlineApplicationsData.appActivities[
                    this.dataObj.appId
                  ][lastAct].data.quotations;
                break;
              case taskTypesDef.CustomerComplaint.type:
                activity = {
                  ComplaintTypeId: this.dataObj.complaint.complaintTypeId,
                  ComplaintSubtypeId: this.dataObj.complaint.complaintSubtypeId,
                  ConnectionId: Number(this.dataObj.complaint.connectionId),
                  PropertyId: Number(this.dataObj.complaint.propertyId),
                  Description: this.dataObj.complaint.description,
                  ProblemLocation: this.dataObj.complaint.problemLocation,
                  IsOwner: this.dataObj.complaint.isOwner,
                };
                break;
              case taskTypesDef.GetMeterReading.type:
                activity = JSON.parse(
                  JSON.stringify(this.dataObj.readings[0].currentReading)
                );
                break;
              case taskTypesDef.SelectMeter.type:
                activity = JSON.parse(
                  JSON.stringify(
                    this.dataObj.meterModel &&
                      this.dataObj.meterModel.isNewMeter
                      ? this.dataObj.customMeterModel
                      : this.dataObj.meterModel
                  )
                );
                break;
              case taskTypesDef.IssueJobcard.type:
                activity = JSON.parse(JSON.stringify(this.dataObj.appData));
                break;
              case taskTypesDef.SelectCustomer.type:
                activity = {
                  customerKey: this.dataObj.customer.customerKey,
                  propertyId: this.dataObj.propertyId,
                };
                break;
              case taskTypesDef.SelectProperty.type:
                activity = {
                  propertyId: this.dataObj.property.propertyId,
                };
                break;
              case taskTypesDef.SelectConnection.type:
                activity = {
                  connectionID: this.dataObj.connectionId,
                };
                break;
            }

            let payload = {
              _id: this.dataObj.appId,
              applicationId: Number(this.dataObj.appId),
              applicationType:
                this.$store.state.offlineApplicationsData.appViews.filter(
                  (a) => a.applicationId == this.dataObj.appId
                )[0].applicationTypeS,
              activities: [
                {
                  activityId:
                    this.$store.state.offlineApplicationsData
                      .appKeyToActivityInfo[lastAct].activityType,
                  appKey: lastAct,
                  activityStr:
                    this.$store.state.offlineApplicationsData
                      .appKeyToActivityInfo[lastAct].activityStr,
                  activity,
                  customFieldValues:
                    this.$store.state.offlineApplicationsData.appActivities[
                      this.dataObj.appId
                    ][lastAct].customFields,
                  location: {
                    ApplicationId: this.dataObj.appId,
                    CoordLat: this.gMapPositions[0].lat,
                    CoordLong: this.gMapPositions[0].lng,
                  },
                },
              ],
            };

            this.$store.state.csLocalDB
              .put(payload)
              .then((res) => {
                this.checkNextActivity();
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.gMapPositions[0] = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
  },
};

const taskTypesDef = {
  SelectMeter: { name: "Select Meter", type: 15 },
  GetMeterReading: { name: "Get Meter Reading", type: 20 },
  CustomerComplaint: { name: "Customer Complaint", type: 28 },
  Quotation: { name: "Quotation", type: 51 },
  InvestigationOutcome: { name: "Investigation Outcome", type: 69 },
  IssueJobcard: { name: "Jobcard", type: 93 },
  SelectCustomer: { name: "SelectCustomer", type: 1 },
  SelectProperty: { name: "SelectProperty", type: 3 },
  SelectConnection: { name: "SelectConnection", type: 27 },
};
